// extracted by mini-css-extract-plugin
export default {"container":"MainAssetsCard_container__UE3Dy"};